import { useEffect } from "react";
//context
import { useGlobalContext } from "../../contexts";
//apollo
import client from "../../src/utils/apollo/client";
//queries
import { GET_PRODUCTS_AND_CATEGORIES_URI } from "../../src/queries/products/get-products-and-categories-uri";
import { GET_PRODUCT_OR_CATEGORY } from "../../src/queries/products/get-product-or-category";
//routing
import { useRouter } from "next/router";
import { FALLBACK, handleRedirectsAndReturnData } from '../../src/utils/slug';
//externals
import { isEmpty } from "lodash";
//components
import Layout from "../../src/components/layout";

const ProductAndCategory = ( { data } ) => {
  const router = useRouter();
  if( router.isFallback ) {
    return <div>Loading...</div>
  }

  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

  return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      pt_key={data?.pt_key}
      templateWhite={false}
      programms={data?.programms}
      armchairs={data?.armchairs?.nodes}
      systems={data?.systems?.nodes}
      armchairTagLine={data?.content?.acfArmchairs?.excerpt}
      accessories={data?.accessories?.nodes}
      optionsFooter={'withContact'}
      productFeaturedImage={data?.content?.featuredImage?.node}
      programmInfo={data?.content?.acfProgramms}
      systemTagLine={data?.content?.acfSystems?.excerpt}
    >

    </Layout>
  )
}

export default ProductAndCategory;

export async function getStaticProps( {params} ) {
  const slugs = (params?.slug ?? []).filter(Boolean);
  // category = 1 segment, product = category/product → always resolve by last slug
  const uri = slugs[slugs.length - 1] ?? '';

  // Bogus paths (e.g. iframe HTML leaked into the URL) or empty slug:
  // produit(id: "", SLUG) wrongly resolves to the homepage with no categories
  if (
    !uri
    || slugs.length > 2
    || uri.includes('<')
    || /iframe|script|javascript:/i.test(uri)
  ) {
    return { notFound: true };
  }

  const { data: data, errors: errors } = await client.query({
    query: GET_PRODUCT_OR_CATEGORY(process.env.PRODUCT_CATEGORY_PT_KEY, process.env.PRODUCT_PT_KEY),
    variables: {
      uri: uri,
      armchairsCategoryId: parseInt(process.env.PRODUCT_ARMCHAIRS_CATEGORY_ID),
      programmsCategoryId: parseInt(process.env.PRODUCT_PROGRAMM_CATEGORY_ID),
      accessoriesCategoryId: parseInt(process.env.PRODUCT_ACCESSORIES_CATEGORY_ID),
      systemsCategoryId: parseInt(process.env.PRODUCT_SYSTEMS_CATEGORY_ID)
    }
  });

  if (data.category == null && data.produit == null) {
    data.content = null
  } else {
    if (data.category == null) {
      data.content = data.produit;
      const categoryNode = data.content?.categories?.nodes?.[0];
      const categoryCrumb = categoryNode?.seo?.breadcrumbs?.[0];
      if (categoryCrumb?.text && categoryNode?.uri && data.content?.seo?.breadcrumbs) {
        data.content.seo.breadcrumbs.splice(data.content.seo.breadcrumbs.length - 1, 0, {
          text: categoryCrumb.text,
          url: categoryNode.uri,
        });
      }
      data.pt_key = process.env.PRODUCT_PT_KEY;
    } else {
      data.content = data.category;
      data.content?.seo?.breadcrumbs?.unshift({text: 'Nos produits', url: '/nos-produits/'});
      data.pt_key = process.env.PRODUCT_CATEGORY_PT_KEY
    }
  }

  const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 60,
	};

  return handleRedirectsAndReturnData( defaultProps, data, errors, { allowNotFound: true } );
};

export async function getStaticPaths(context) {
  const { data } = await client.query({
    query: GET_PRODUCTS_AND_CATEGORIES_URI
  });

  const pathsData = [];

  const toSlugParams = (uri) => {
    const slugs = uri.split('/').filter(Boolean);
    // page lives under /nos-produits/[...slug] — drop the folder prefix from WP uris
    if (slugs[0] === 'nos-produits') slugs.shift();
    return slugs;
  };

  data?.categories?.nodes &&  data?.categories?.nodes?.map( category => {
    if (! isEmpty( category?.uri ) && category?.uri != '/nos-produits/nos-fauteuils/comparer/') {
      const slugs = toSlugParams(category.uri);
      if (slugs.length) pathsData.push( {params: { slug: slugs }} );
    }
  });
  data?.produits?.nodes &&  data?.produits?.nodes?.map( produit => {
    if (! isEmpty( produit?.uri ) && produit?.uri != '/nos-produits/nos-fauteuils/comparer/') {
      const slugs = toSlugParams(produit.uri);
      if (slugs.length) pathsData.push( {params: { slug: slugs }} );
    }
  });

  return {
    paths: pathsData,
    fallback: FALLBACK,
  }
}